'use client'

import type { ComponentProps, ReactNode } from 'react'
import { clsx } from 'clsx'
import { describedBy, Field } from '@/ui/Field'
import { CheckIcon } from '@/ui/icons/CheckIcon'

type Props = Omit<ComponentProps<'input'>, 'type'> & {
  id: string
  label: ReactNode
  error?: string
  className?: string
}

export function Checkbox({ id, label, error, className, ...props }: Props) {
  return (
    <Field fieldId={id} error={error} className={className}>
      <div className="group flex min-h-6 items-start gap-2.5">
        <span className="relative flex shrink-0">
          <input
            id={id}
            type="checkbox"
            {...props}
            aria-describedby={describedBy(id, error, props['aria-describedby'])}
            aria-invalid={error ? true : props['aria-invalid']}
            className={clsx(
              'peer size-4.5 cursor-pointer appearance-none rounded-[0.1875rem] border border-primary-500 bg-white',
              'checked:border-primary-500 checked:bg-primary-500',
              'focus-visible:focus-ring',
              'disabled:cursor-not-allowed disabled:border-neutral-400'
            )}
          />
          <CheckIcon className="pointer-events-none absolute inset-0 m-auto hidden w-3.5 text-white peer-checked:block" />
        </span>
        <label
          htmlFor={id}
          className="cursor-pointer text-checkbox text-neutral-800 group-has-disabled:cursor-not-allowed"
        >
          {label}
        </label>
      </div>
    </Field>
  )
}
